<mat-toolbar>
  <span class="spacer"></span>
  <p>Free Shipping | Total price: €{{this.service.calculateTotalPrice()}}</p>
</mat-toolbar>

<div class="divsContainer">
  <div class="imageDiv">
      <img class="desktopImage" src="{{this.selectedImage}}" alt="">
  </div>
  <div *ngFor="let x of pages | async" [ngClass]="{'page': (x.position == selected), 'page' : (x.position == selected)}">
    <div *ngIf="x.position == selected" class="container">
      <h1 class="header1">{{x.title}}</h1>
      <p class="header1Text">{{x.titleText}}</p>
      <img class="imageShown" src="{{this.selectedImage}}" alt="">
      <div *ngIf="!x.isEngravingPage" class="listOfOptions">
        <div *ngFor="let a of x.features" (click)="voegToeAanLijst(a)" class="optionBox">
          <p class="optionHeader"> {{a.optionName}} </p>
          <div [ngClass]="{'selected': this.service.isInCart(a)}" class="option">
            <img class="optionImage" src="{{a.optionImage}}" alt="">
            <div class="optionPrice">
              <p>+ €{{a.optionPrice}} </p>
            </div>
          </div>
        </div>
      </div>
      <!-- engraving section -->
      <div *ngIf="x.isEngravingPage" class="engravingDiv">
       <div class="headerAndTextEngraving">
          <h1 class="header1">{{x.engravingTitle}}</h1>
          <p> {{x.aboutEngraving}} </p>  
       </div>
       <div class="engraving-radio-div">
          <mat-radio-group style="display: flex;
          justify-content: center;"
          [(ngModel)]="selectedEngravingOptie"
          (change)="getValue(x.features[0])">
            <mat-radio-button 
            style="margin: 20px; font-family: 'avenir-medium'; font-size: 13px;" 
            *ngFor="let optie of opties" [value]="optie.value">
              {{optie.text}}
            </mat-radio-button>
          </mat-radio-group>
      </div>
        <div *ngIf="selectedEngravingOptie" class="engraving-form-div zoomIn" [formGroup]="engravingForm">
            
            <p style="text-align: center; margin-top: 20px;
            margin-bottom: -20px;">{{x.engravingFormNotice}}</p>

            <mat-form-field class="matFormField top" appearance="outline">
                <mat-label>Field A</mat-label>
                <input (keydown.backspace)="removeFromList(x.features[0])" maxlength="12" formControlName="a_field" matInput>
                <mat-icon *ngIf="engravingForm.controls.a_field.value.length > 0" [ngClass]="{'ok': engravingForm.controls.a_field.valid, 'error' : engravingForm.controls.a_field.invalid}" svgIcon="{{engravingForm.controls.a_field.valid ? 'ok' : 'cancel'}}" matSuffix></mat-icon>
                <mat-error *ngIf="engravingForm.controls.a_field.invalid">Your input contains not allowed characters.</mat-error>
              </mat-form-field>
    
            <mat-form-field class="matFormField" appearance="outline">
                <mat-label>Field B</mat-label>
                <input (keydown.backspace)="removeFromList(x.features[0])"  maxlength="12" formControlName="b_field" matInput>
                <mat-icon *ngIf="engravingForm.controls.b_field.value.length > 0" [ngClass]="{'ok': engravingForm.controls.b_field.valid, 'error' : engravingForm.controls.b_field.invalid}" class="formIcon" svgIcon="{{engravingForm.controls.b_field.valid ? 'ok' : 'cancel'}}" matSuffix></mat-icon>
                <mat-error *ngIf="engravingForm.controls.b_field.invalid">Your input contains not allowed characters.</mat-error>
              </mat-form-field>
    
              <mat-form-field class="matFormField" appearance="outline">
                <mat-label>Your email address</mat-label>
                <input (keydown.backspace)="removeFromList(x.features[0])" formControlName="email" matInput>
                <mat-icon *ngIf="engravingForm.controls.email.value.length > 0" [ngClass]="{'ok': engravingForm.controls.email.valid, 'error' : engravingForm.controls.email.invalid}" class="formIcon" svgIcon="{{engravingForm.controls.email.valid ? 'ok' : 'cancel'}}" matSuffix></mat-icon>
                <mat-error *ngIf="engravingForm.controls.email.invalid">Your email is not valid.</mat-error>
              </mat-form-field>
    
              <p *ngIf="formChecker()" style="text-align: center;">Fill in the field(s) to add engraving to  your cart.</p>
              <div (click)="addEngraving(x.features[0])" [ngClass]="{'selectedButton': this.service.isInCart(x.features[0]), 'disabled': formChecker()}" class="engraveAddButton">
                <p>{{this.service.isInCart(x.features[0]) ? 'engraving added!' : 'add engraving + €50'}}</p>
              </div>
        </div>
      </div>
      <!-- About Feature Section -->
      <h1 class="header1 aboutHeader">{{x.aboutTitle}}</h1>
      <p class="aboutText">{{x.aboutFeatureText}}</p>
      <!-- List of Features -->
      <div *ngIf="!x.isEngravingPage" class="featureList">
        <div *ngFor="let f of x.aboutList" class="featureItem">
          <div class="icon">
            <mat-icon svgIcon="ok"></mat-icon>
          </div>
          <div class="listText">
            <p>{{f}}</p>
          </div>
        </div>
      </div>
      <!-- FAQ -->
      <div class="faq">
        <h1 class="header1 faqHeader">
          frequently asked questions
        </h1>
      </div>
      <div class="faqList">
        <div class="divider pbottom"></div>
        <mat-expansion-panel *ngFor="let z of x.faqList; let i = index;" (click)="chevronSwitcher(i)"  hideToggle>
          <mat-expansion-panel-header>
            <mat-panel-title>{{z.title}}</mat-panel-title>
            <mat-panel-description>
              <mat-icon class="smallIcon" svgIcon="{{panelChecker(i) ? 'chevron-up' : 'chevron-down'}}"></mat-icon>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <p style="margin: 0">{{z.text}}</p>
        </mat-expansion-panel>
        <div class="divider ptop"></div>
      </div>
    </div>
  </div>
</div>

<!-- footer -->
<div class="stickyFooter">
  <!-- back button -->
  <div (click)="goBack()" class="backButton">
    <mat-icon svgIcon="chevron-left" class="backIcon"></mat-icon>
    <p class="backText">Back</p>
  </div>
  <!-- div for stepper -->
  <div class="stepper">
    <!-- <div *ngFor="let item of stepperPos" class="selected == item.position ? step : step selectedStep"></div> -->
    <div class="stepBox" *ngFor="let i of stepperPos" >
        <div [ngClass]="{'step' : true, 'selectedStep': (i.position == selected), 'passed' : (i.position < selected) }"></div>
        <p class="stepperTitle">{{i.title}}</p>
    </div>
  </div>
  <!-- next button -->
  <div [ngClass]="{'nextButton': true, 'checkout' : stepperPos.length == selected}" (click)="nextPage()">
    <p class="stepperText">{{stepperPos.length != selected ? "next" : "checkout"}}</p>
    <mat-icon svgIcon="chevron-right" class="backIcon"></mat-icon>
  </div>
</div>